export default function Header() {
  return (
    <header>
      <h1>MA'AD Admin Panel</h1>
    </header>
  );
}
